import { render, staticRenderFns } from "./MinNav.vue?vue&type=template&id=22898c5c&scoped=true&"
import script from "./MinNav.vue?vue&type=script&lang=js&"
export * from "./MinNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22898c5c",
  null
  
)

export default component.exports